import { render } from "./PalettePicker.vue?vue&type=template&id=6595f309"
import script from "./PalettePicker.vue?vue&type=script&lang=js"
export * from "./PalettePicker.vue?vue&type=script&lang=js"

import "./PalettePicker.vue?vue&type=style&index=0&id=6595f309&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__